import { useEffect } from 'react';
import { initMetaPixel } from '@/lib/metaPixel';

/**
 * Component to initialize Meta Pixel on app mount
 * Should be rendered once at the app root level
 */
const MetaPixelInitializer = () => {
  useEffect(() => {
    initMetaPixel();
  }, []);

  return null;
};

export default MetaPixelInitializer;
